import techBanner from './bannerimages/techBanner.png';
import techCard from './bannerimages/techCard.png';
import mediaBanner from './bannerimages/mediaBanner.png';
import mediaCard from './bannerimages/mediaCard.png';
import designBanner from './bannerimages/designBanner.png';
import designCard from './bannerimages/designCard.png';
import scienceBanner from './bannerimages/scienceBanner.png';
import scienceCard from './bannerimages/scienceCard.png';

export const Images = {
  techBanner: techBanner,
  techCard: techCard,
  mediaBanner: mediaBanner,
  mediaCard: mediaCard,
  designBanner: designBanner,
  designCard: designCard,
  scienceBanner: scienceBanner,
  scienceCard: scienceCard,
};
